"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _styles = require("../styles");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Cube = function Cube(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor,
    _ref$animation = _ref.animation,
    animation = _ref$animation === void 0 ? '' : _ref$animation;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/React.createElement(_styles.Svg, {
    width: size,
    height: size,
    fill: "none",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className, " ").concat(animation)
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.057 6.72a.69.69 0 0 0-.064-.235c-.012-.02-.016-.044-.028-.064a.706.706 0 0 0-.2-.208l-5.44-3.428a.66.66 0 0 0-.676-.016L4.017 5.985a.669.669 0 0 0-.22.216c-.016.024-.024.048-.036.072a.61.61 0 0 0-.064.236c0 .02-.016.032-.016.052v6.384c0 .22.112.428.296.548l5.632 3.72c.012.008.024.004.032.008.012.008.016.02.028.024.096.048.2.072.3.072a.615.615 0 0 0 .312-.08c.012-.008.02-.024.032-.032s.024-.004.036-.012l5.436-3.852a.663.663 0 0 0 .276-.536V6.769c.008-.016-.004-.032-.004-.048Zm-6.1-2.611 4.232 2.668L9.977 9.5l-4.38-2.9 4.36-2.492ZM5 7.78l4.316 2.86v4.796L5 12.585V7.78Zm9.752 4.684-4.12 2.92v-4.74l4.12-2.668v4.488Z",
    fill: color,
    fillOpacity: 0.8
  }));
};
var _default = exports["default"] = Cube;